import type { SVGProps } from "react";
const SvgViva = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      background: "new 0 0 69.4 50",
    }}
    viewBox="0 0 69.4 50"
    {...props}
  >
    <g transform="translate(0 .342)">
      <defs>
        <filter
          id="viva_svg__a"
          width={69.4}
          height={50}
          x={0}
          y={-0.3}
          filterUnits="userSpaceOnUse"
        >
          <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
        </filter>
      </defs>
      <mask id="viva_svg__b" width={69.4} height={50} x={0} y={-0.3} maskUnits="userSpaceOnUse">
        <g
          style={{
            filter: "url(#viva_svg__a)",
          }}
        >
          <path
            d="M0-.3h69.4v50H0z"
            style={{
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#fff",
            }}
          />
        </g>
      </mask>
      <path
        d="M21 40.4c1.1 2.2 2.7 3.5 4.6 3.6 1.8 0 3.4-1.3 4.6-3.5l1.5-3.1-14.2-30L7.7 12zm18.5.1c1.1 2.2 2.8 3.5 4.6 3.5s3.5-1.3 4.6-3.5L61.9 12 52 7.3l-14 30zm4.5 9.2c-3.7 0-7.1-2.1-9.2-5.7-2.1 3.6-5.5 5.7-9.2 5.7h-.1c-4 0-7.6-2.6-9.7-6.8L0 9.1 20.2-.3l14.6 30.9L49.2-.3l20.2 9.4-15.6 33.7c-2.1 4.3-5.7 6.8-9.8 6.9.1 0 0 0 0 0"
        style={{
          mask: "url(#viva_svg__b)",
          fillRule: "evenodd",
          clipRule: "evenodd",
          fill: "#1f263a",
        }}
      />
    </g>
  </svg>
);
export default SvgViva;
